import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrow-bold-right",
  "use": "app-icon-arrow-bold-right-usage",
  "viewBox": "0 0 9 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 12\" id=\"app-icon-arrow-bold-right\"><path d=\"M8.5 6l-8 5.5V.5z\" fill=\"#1B8ADB\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol